import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/base/ScrollToTop";
import HeroSection from "./components/HeroSection";
import FeaturedArticles from "./components/FeaturedArticles";
import CategoriesSection from "./components/CategoriesSection";
import LatestArticles from "./components/LatestArticles";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Po文完全指南",
  url: "https://powen.guide",
  description: "最全面的中文Po文创作指南，提供po文标题撰写、内容排版、最佳发布时机等完整策略，帮助创作者提升互动率与触及率。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://powen.guide/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    { "@type": "Question", name: "什么是Po文？Po文是什么意思？", acceptedAnswer: { "@type": "Answer", text: "Po文源自英文「Post」，指的是在社交媒体、论坛、部落格等平台上发布的文章或贴文。在台湾和香港的网络用语中，「Po文」已经成为日常用语，泛指在网络上发表内容的行为。" } },
    { "@type": "Question", name: "Po文怎么写才能获得更多互动？", acceptedAnswer: { "@type": "Answer", text: "提高po文互动率的关键在于三个方面：一是标题要有吸引力，善用数字、问题、对比等技巧；二是内容要有价值，提供实用信息或情感共鸣；三是排版要清晰易读，善用分段、符号和留白。" } },
    { "@type": "Question", name: "Po文最佳发布时间是什么时候？", acceptedAnswer: { "@type": "Answer", text: "不同平台的最佳时间有所不同：Facebook建议工作日9:00-11:00和19:00-21:00；Instagram推荐12:00-13:00和20:00-22:00；Threads则在8:00-10:00和17:00-19:00表现最佳。" } },
    { "@type": "Question", name: "新手学Po文应该从哪里开始？", acceptedAnswer: { "@type": "Answer", text: "建议从「模仿 + 练习」开始。先关注你所在领域的优秀创作者，分析他们po文的标题、结构和排版方式，然后尝试用自己的语言和角度来创作。从短篇内容开始练习，逐步提升。" } },
    { "@type": "Question", name: "Po文排版真的那么重要吗？", acceptedAnswer: { "@type": "Answer", text: "非常重要！研究显示，排版良好的内容完读率比排版本混乱的内容高出3-5倍。在移动端阅读场景下，清晰的排版直接决定了读者是否会读完你的内容。" } },
  ],
};

export default function Home() {
  useEffect(() => {
    document.title = "Po文完全指南 - 让你的Po文获得最高曝光";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", "想让你的po文脱颖而出？本页提供po文的完整策略，从po文标题撰写、内容排版到最佳发布时机，帮助创作者掌握po文技巧，提升互动率与触及率。");
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) metaKw.setAttribute("content", "po文,po文技巧,po文怎么写,po文范例,po文排版,po文互动率提升,po文最佳时间");
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategoriesSection />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />

      <script type="application/ld+json">
        {JSON.stringify(homeSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </>
  );
}